@use '@/styles/variables' as *;

.footer {
  border-top: 1px solid var(--border);
  padding: 1.5rem $section-padding-x;
}

.inner {
  max-width: $container-max-width;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.copy,
.tagline {
  font-size: 0.8rem;
  color: var(--muted-foreground);
}

@media (max-width: #{$breakpoint-sm}) {
  .inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
}
